import { Layers, IconLayerOptions } from '../models';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { MapboxHelper } from '../mapbox-map-helper';
import { Theme } from 'src/app/modules/shared/models';

import * as _ from 'lodash';

export class RenderStopsLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light
    ) {
        super(_mapboxHelper);
    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[Layers.Stops] = [];

        const stopIconlayerId = `${Layers.Stops}`;
        if (!this._mapboxHelper.layerExists(map, stopIconlayerId)) {
            let layerNames = [];
            const options = this._mainStopOptions();
            layerNames = this._mapboxHelper.renderIcon(map, this._sourceId, this._sourceLayer, stopIconlayerId, options);
            layers[Layers.Stops] = layers[Layers.Stops].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    //#region rendering options for layers connected to stops
    private _mainStopOptions(): IconLayerOptions {
        const options = new IconLayerOptions();
        options.icon = ['step', ['zoom'], 'dot-10', 11, 'stop'];
        options.iconColor = '#0078D7';
        options.iconSize = [
            'step',
            ['zoom'],
            0,
            7,
            0.3,
            10,
            0.7,
            11,
            0.8
        ];
        options.text = ['to-string', ['get', 'title']];
        options.textSize = [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            10,
            15,
            11,
            16,
            12,
            22,
            12
        ];
        options.textOffset = [
            'step',
            ['zoom'],
            ['literal', [0, -1.2]],
            15,
            ['literal', [0, -1.5]]
        ];
        options.textFont = ['case',
            ['boolean', ['get', 'isTimingPoint'], false],
            ['literal', ['Open Sans Bold']],
            ['literal', ['Open Sans Regular']]
        ];
        options.textMaxWidth = 8;
        options.visibleFrom = 10;
        options.visibleTo = 24;
        options.visibility = true;
        options.textAnchor = 'bottom';
        options.textColor = ['case',
            ['boolean', ['get', 'selected'], true],
            '#0078D7',
            this._theme === Theme.Light ? '#000000' : '#ffffff'
        ];
        options.textHaloColor = this._theme === Theme.Light ? '#ffffff' : '#000000';
        options.textHaloWidth = 2;
        options.textOpacity = ['step', ['zoom'], 0, 10, 1, 13.5, 1, 24, 1];
        options.layerBefore = Layers.Vehicle;
        options.textAllowOverlap = false;

        return options;
    }
    //#endregion

}


